<div (click)="onClick()" class="wrapper">
  <div
    class="map-control-btn"
    [ngClass]="{ 'mobile-btn': isMobile, 'btn-label': showLabel }"
    ngbTooltip="Натиснете тук за да центрирате картата в/у вашето местоположение"
    placement="top"
  >
    <i class="fa fa-dot-circle-o"></i>
    <span *ngIf="showLabel">Pin to my location</span>
  </div>
</div>
